import React from 'react';
import { BLOCKS, INLINES } from "@contentful/rich-text-types";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { useStaticQuery, graphql } from "gatsby";

// Components //
import Breadcrumb from '../../atoms/breadcrumb/breadcrumb'; 

// Interfaces //
import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";

// Styles //
import "./normativity.scss";

const Normativity = (props: ReferenciaContenido) => {
    const {
        tituloGeneral,
        descripcion,
    } = props;

    const icons = useStaticQuery(graphql`
        query NORMAICONS {
            iconDocument: allContentfulAsset(
                filter: { title: { eq: "icon-documento" } }
            ) {
                nodes {
                    file {
                        url
                    }
                }
            }
            iconDownload: allContentfulAsset(
                filter: { title: { eq: "icon-descargar" } }
            ) {
                nodes {
                    file {
                        url
                    }
                }
            }
        }
    `);

    const iconDocument: string = icons.iconDocument.nodes[0].file.url;
    const iconDownload: string = icons.iconDownload.nodes[0].file.url;

    const contentfulRenderOptions = {
        renderNode: {
            [INLINES.HYPERLINK]: ({ data }, children) => (
                <a
                    style={{ color: "var(--color-magenta-white)" }}
                    href={data.uri}
                    target={"_blank"}
                    rel={"noopener noreferrer"}
                >
                    <img src={iconDownload} alt="" /> {children}
                </a>
            ),
            [BLOCKS.PARAGRAPH]: (node, children) => {
                return <p className="small-note"><img src={iconDocument} alt="" />{children}</p>;
            },
            [BLOCKS.EMBEDDED_ASSET]: (node, children) => {
                return (
                    <p>
                        <img
                            src={`${node.data.target.fields.file.url}`}
                            alt={node.data.target.fields.description}
                        />
                    </p>
                );
            },
        },
        renderText: (text) =>
            text.split("\n").flatMap((text, i) => [i > 0 && <br />, text]),
    };
    
    return (
        <div className='o-normativity'>
            <div className='container'>
                <Breadcrumb content={`Inicio / Normatividad legal`} />
                <div className='o-normativity__header'>
                    <h1>{tituloGeneral}</h1>
                </div>
                <div className='o-normativity__description'>
                    {descripcion.json &&
                        documentToReactComponents(
                            descripcion.json, contentfulRenderOptions
                    )}
                </div>
            </div>
        </div>
    )
}

export default Normativity;